import request, { privateRequest } from "lib/request";

const API_URL = "/api/products";

export const fetchProductsAPI = async (pageConfig) => {
  try {
    const response = await privateRequest.get(API_URL, pageConfig);
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const fetchProductsByCategorySlugAPI = async (
  categorySlug,
  pageConfig
) => {
  try {
    const response = await request.get(
      `/api/categories/${categorySlug}/products`,
      pageConfig
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const fetchProductByIdAPI = async (id) => {
  try {
    const response = await privateRequest.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const createProductAPI = async (data) => {
  try {
    const response = await privateRequest.post(API_URL, data, {
      "Content-Type": "multipart/form-data",
    });
    return response.data;
  } catch (error) {
    console.error("Error creating product:", error);
    throw error;
  }
};

export const deleteProductAPI = async (id) => {
  try {
    const response = await privateRequest.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting product:", error);
    throw error;
  }
};

export const updateProductAPI = async (id, data) => {
  try {
    const response = await privateRequest.put(`${API_URL}/${id}`, data, {
      "Content-Type": "multipart/form-data",
    });
    return response.data;
  } catch (error) {
    console.error("Error updating product:", error);
    throw error;
  }
};
